/**
 * Values of the vehicle captured in the form, in the order the requester fills
 * them. The carrier company is the only one that takes the whole row.
 *
 * Every value is optional for the requester, so each one says who wrote it: the
 * one the folio was registered with names the requester and the one completed
 * at the gate names the guard.
 */
export const VEHICLE_ROWS = [
    {trans: 'tractor', field: 'tractor', registered: true},
    {trans: 'trailer', field: 'trailer', registered: true},
    {trans: 'driver_s_name', field: 'driversName', registered: true},
    {trans: 'seal_number', field: 'sealNumber', registered: true}
];

/**
 * Maximum length a quantity of packaging accepts.
 *
 * The field is read next to the unit it counts, so what is written has to fit
 * beside it: a return of crates is counted in thousands and not in millions,
 * and a quantity that does not fit is displayed cut once the field is only read.
 */
export const PACKAGING_QUANTITY_LENGTH = 6;

